// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__uBzPH","wrapperIsHidden":"Layout_wrapperIsHidden__3PUq1","svg":"Layout_svg__T0lkH"};